import { TrendingUp, TrendingDown, Wallet, Clock } from 'lucide-react';
import type {
    FinancialStats,
    ChartDataPoint,
    School,
    Transaction,
    BankAccount,
    Account,
    Deposit,
    Transfer,
    Staff,
    Student
} from '../types';

// SMP Students Data
export const smpStudents: Student[] = [
    {
        id: 'SMP001',
        name: 'Rafi Ahmad',
        parentName: 'Gading Marten',
        class: 'Kelas 7A',
        status: 'active',
        tuitionStatus: 'paid',
        totalBill: 'Rp 1.500.000',
        receivable: 'Rp 0',
        schoolId: 'smp-pekanbaru',
        paymentHistory: [
            { id: 'PH_SMP_01', date: '2025-02-01', amount: 'Rp 750.000', method: 'Transfer', status: 'success', receiptNo: 'INV/SMP/001' },
            { id: 'PH_SMP_02', date: '2025-01-01', amount: 'Rp 750.000', method: 'Transfer', status: 'success', receiptNo: 'INV/SMP/002' },
        ]
    },
    {
        id: 'SMP002',
        name: 'Luna Maya',
        parentName: 'Reino Barack',
        class: 'Kelas 8B',
        status: 'active',
        tuitionStatus: 'pending',
        totalBill: 'Rp 1.500.000',
        receivable: 'Rp 750.000',
        amount: 'Rp 750.000',
        schoolId: 'smp-siak',
        paymentHistory: [
            { id: 'PH_SMP_03', date: '2025-01-05', amount: 'Rp 750.000', method: 'Cash', status: 'success', receiptNo: 'INV/SMP/003' },
        ]
    },
];

// SMP Sub-Schools List
export const smpSchools: School[] = [
    {
        id: 'smp-pekanbaru',
        name: 'SMP Al-Azhar Pekanbaru',
        income: '150.2 Jt',
        expense: '65.4 Jt',
        balance: '84.8 Jt',
        receivable: '4.2 Jt',
        color: 'bg-warning-soft text-warning',
        icon: TrendingUp
    },
    {
        id: 'smp-siak',
        name: 'SMP Al-Azhar Siak',
        income: '120.5 Jt',
        expense: '45.2 Jt',
        balance: '75.3 Jt',
        receivable: '3.5 Jt',
        color: 'bg-warning-soft text-warning',
        icon: TrendingUp
    },
    {
        id: 'smp-kerinci',
        name: 'SMP Al-Azhar Kerinci',
        income: '109.5 Jt',
        expense: '40.3 Jt',
        balance: '69.2 Jt',
        receivable: '4.1 Jt',
        color: 'bg-warning-soft text-warning',
        icon: TrendingUp
    },
];

// SMP Unit Financial Statistics
export const smpStats: FinancialStats[] = [
    {
        label: 'Pendapatan Unit',
        value: 'Rp 380.200.000',
        change: '+9.8%',
        icon: TrendingUp,
    },
    {
        label: 'Pengeluaran Unit',
        value: 'Rp 150.900.000',
        change: '+6.2%',
        icon: TrendingDown,
    },
    {
        label: 'Saldo Kas Unit',
        value: 'Rp 229.300.000',
        change: '+13.5%',
        icon: Wallet,
    },
    {
        label: 'Piutang Siswa',
        value: 'Rp 11.800.000',
        change: '-4.2%',
        icon: Clock,
    },
];

// SMP Bank Accounts
export const smpBankAccounts: BankAccount[] = [
    {
        id: 'BANK-SMP-001',
        bankName: 'BCA',
        accountNumber: '7788xxxx11',
        accountName: 'SMP Al-Azhar Unit Yayasan',
        balance: 'Rp 150.000.000',
        type: 'Rekening Operasional',
        linkedAccount: '1-1100 (Bank BCA)',
        status: 'active',
    },
    {
        id: 'BANK-SMP-002',
        bankName: 'Mandiri',
        accountNumber: '9900xxxx22',
        accountName: 'SMP Al-Azhar Unit - Dana BOS',
        balance: 'Rp 79.300.000',
        type: 'Rekening BOS',
        linkedAccount: '1-1110 (Bank Mandiri)',
        status: 'active',
    },
];

// SMP Chart of Accounts
export const smpAccounts: Account[] = [
    {
        id: 'ACC-SMP-1000',
        code: '1-1000',
        name: 'Kas SMP',
        type: 'asset',
        balance: 'Rp 229.300.000',
    },
    {
        id: 'ACC-SMP-4000',
        code: '4-1000',
        name: 'Pendapatan SPP SMP',
        type: 'income',
        balance: 'Rp 320.000.000',
    },
    {
        id: 'ACC-SMP-5000',
        code: '5-1000',
        name: 'Gaji Guru SMP',
        type: 'expense',
        balance: 'Rp 95.000.000',
    },
];

// SMP Transactions
export const smpTransactions: Transaction[] = [
    {
        id: 'TRX-SMP-001',
        type: 'income',
        description: 'Pembayaran SPP Februari - SMP',
        amount: 'Rp 35.000.000',
        date: '2025-02-01',
        category: 'SPP',
    },
    {
        id: 'TRX-SMP-002',
        type: 'expense',
        description: 'Biaya Lomba Sains Nasional',
        amount: 'Rp 4.500.000',
        date: '2025-01-28',
        category: 'Kesiswaan',
    },
];

// SMP Deposits
export const smpDeposits: Deposit[] = [
    {
        id: 'DEP-SMP-001',
        date: '2025-02-01',
        type: 'masuk',
        amount: 'Rp 35.000.000',
        description: 'Setoran SPP Kolektif SMP',
        bankAccountId: 'BANK-SMP-001',
        status: 'completed',
    },
];

// SMP Transfers
export const smpTransfers: Transfer[] = [
    {
        id: 'TRF-SMP-001',
        date: '2025-01-25',
        fromUnit: 'SMP',
        toUnit: 'SD',
        amount: 'Rp 2.000.000',
        description: 'Bantuan subsidi silang sarpras SD',
        status: 'completed',
    },
];

// SMP Staff Data
export const smpStaff: Staff[] = [
    {
        id: 'STF-SMP-001',
        name: 'Zulkifli, M.Pd',
        position: 'Kepala Sekolah',
        department: 'Manajemen',
        status: 'active',
        schoolId: 'smp-pekanbaru',
    },
    {
        id: 'STF-SMP-002',
        name: 'Hasan Basri, S.Pd',
        position: 'Guru Matematika',
        department: 'Pengajaran',
        status: 'active',
        schoolId: 'smp-siak',
    },
    {
        id: 'STF-SMP-003',
        name: 'Siti Aminah, S.Ag',
        position: 'Guru Agama',
        department: 'Pengajaran',
        status: 'active',
        schoolId: 'smp-pekanbaru',
    },
    {
        id: 'STF-SMP-004',
        name: 'Andi Pratama',
        position: 'Staf IT',
        department: 'Administrasi',
        status: 'active',
        schoolId: 'smp-siak',
    },
];


// SMP Chart Data (12 Months)
export const smpChartData: ChartDataPoint[] = [
    { month: 'Mar', income: 55000000, expense: 21000000 },
    { month: 'Apr', income: 58000000, expense: 22000000 },
    { month: 'Mei', income: 62000000, expense: 24500000 },
    { month: 'Jun', income: 52000000, expense: 28000000 },
    { month: 'Jul', income: 72000000, expense: 26000000 },
    { month: 'Agu', income: 64000000, expense: 23500000 },
    { month: 'Sep', income: 61000000, expense: 24000000 },
    { month: 'Okt', income: 64000000, expense: 25500000 },
    { month: 'Nov', income: 60000000, expense: 23800000 },
    { month: 'Des', income: 67000000, expense: 27000000 },
    { month: 'Jan', income: 63000000, expense: 25200000 },
    { month: 'Feb', income: 65200000, expense: 25400000 },
];
